import vent from 'elements/vent';
import dialogs from 'elements/dialogs';
import delegator from 'elements/delegator';
import flash from 'elements/flash';
import ui from 'elements/offre-ui';
import offreForm from 'elements/offre-form';
import tabList from 'elements/tab-list';
import faxaj from 'elements/fajax';
;
document.documentElement.classList.add('js');
window.addEventListener('DOMContentLoaded', function (event) {
  // init device context
  window.device = {
    muted: false,
    animation: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    touch: !window.matchMedia('(pointer: fine)').matches,
    ios: navigator && navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
  };
  vent.publish('APP:READY');
});